import PackstationRepository from './PackstationRepository';

export default PackstationRepository;
